import React, { useState } from 'react';
import { FaHeart, FaGavel, FaShoppingCart } from 'react-icons/fa';
import { useAuth } from '../../contexts/AuthContext';
import axios from 'axios';

const LoggedInCard = ({ horse }) => {
  const { user } = useAuth();
  const [bidding, setBidding] = useState(false);
  const [bidAmount, setBidAmount] = useState('');
  const [message, setMessage] = useState('');

  if (!horse || typeof horse !== 'object') {
    return <div className="p-3 bg-red-100 text-red-700">Invalid horse object</div>;
  }

  const {
    id,
    name = 'No Name',
    breed,
    age,
    sex,
    height,
    color,
    images = [],
    price,
    status = 'N/A',
    location = {},
  } = horse;

  const safeBreed = typeof breed === 'object' ? breed.name : breed || 'Unknown';
  const safePrice = typeof price === 'number' ? `$${price.toLocaleString()}` : price || 'N/A';
  const safeImage = images.length > 0 ? images[0] : '/placeholder.jpg';
  const safeCity = location?.details?.city || 'Unknown';
  const safeState = location?.details?.state || 'Unknown';

  const handlePlaceBid = async (e) => {
    e.preventDefault();
    try {
      const enteredBid = parseFloat(bidAmount);
      const minimumBid = horse.currentbid || 0;

      if (isNaN(enteredBid) || enteredBid <= minimumBid) {
        setMessage(`Bid must be higher than $${minimumBid.toLocaleString()}`);
        return;
      }

      await axios.post('/api/bid', {
        horseId: id,
        bidderId: user._id,
        bidAmount: enteredBid,
      });

      setMessage('✅ Bid placed successfully!');
      setBidAmount('');
      setBidding(false);
    } catch (err) {
      console.error('Bid Error:', err);
      setMessage(err.response?.data?.message || 'Failed to place bid.');
    }
  };

  return (
    <div className="relative bg-white border rounded shadow hover:shadow-md overflow-hidden group">
      <div className="h-48 bg-gray-100 overflow-hidden">
        <img src={safeImage} alt={name} className="w-full h-full object-cover" />
      </div>

      <div className="p-3 text-sm">
        <h3 className="font-semibold text-gray-800 truncate">{name}</h3>
        <p><strong>Breed:</strong> {safeBreed}</p>
        <p><strong>Price:</strong> {safePrice}</p>
        <p><strong>Status:</strong> {status}</p>
        <p><strong>Location:</strong> {safeCity}, {safeState}</p>
      </div>

      {user && (
        <div className="flex flex-col space-y-2 px-3 pb-3">
          <div className="flex justify-between items-center">
            <button className="text-gray-600 hover:text-red-500 text-lg">
              <FaHeart />
            </button>
            <button className="text-blue-600 text-xs underline">
              Submit Inquiry
            </button>
          </div>

          {status === 'Active Bid' ? (
            !bidding ? (
              <button
                onClick={() => setBidding(true)}
                className="bg-yellow-500 hover:bg-yellow-600 text-white text-xs px-3 py-1 rounded flex items-center justify-center"
              >
                <FaGavel className="mr-1" /> Place Bid
              </button>
            ) : (
              <form onSubmit={handlePlaceBid} className="space-y-2">
                <input
                  type="number"
                  value={bidAmount}
                  onChange={(e) => setBidAmount(e.target.value)}
                  placeholder="Enter bid"
                  className="w-full border rounded px-2 py-1 text-xs"
                />
                <div className="flex space-x-2">
                  <button type="submit" className="bg-green-600 hover:bg-green-700 text-white text-xs px-3 py-1 rounded w-full">
                    Confirm Bid
                  </button>
                  <button
                    type="button"
                    onClick={() => { setBidding(false); setBidAmount(''); setMessage(''); }}
                    className="bg-gray-400 text-white text-xs px-3 py-1 rounded w-full"
                  >
                    Cancel
                  </button>
                </div>
                {message && <p className="text-xs text-center text-red-500">{message}</p>}
              </form>
            )
          ) : status === 'For Sale' ? (
            <button className="bg-green-600 hover:bg-green-700 text-white text-xs px-3 py-1 rounded flex items-center justify-center">
              <FaShoppingCart className="mr-1" /> Buy
            </button>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default LoggedInCard;